import { OneDataCollection, useDataCollectionSource } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { useOpenDashboardAction } from 'modules/layout/components/RootLayout/FactorialOneLayout/canvas/dashboards/useOpenDashboardAction'

type DiscoverCard = {
  id: string
  description: string
  prompt: string
}

const DiscoverCards = () => {
  const { sendPromptForNewDashboard } = useOpenDashboardAction()

  const DISCOVER_CARDS: DiscoverCard[] = [
    {
      id: 'card-1',
      description: i18n.t('ai_reports.discover.cards.card_1.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_1.prompt'),
    },
    {
      id: 'card-2',
      description: i18n.t('ai_reports.discover.cards.card_2.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_2.prompt'),
    },
    {
      id: 'card-3',
      description: i18n.t('ai_reports.discover.cards.card_3.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_3.prompt'),
    },
    {
      id: 'card-4',
      description: i18n.t('ai_reports.discover.cards.card_4.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_4.prompt'),
    },
    {
      id: 'card-5',
      description: i18n.t('ai_reports.discover.cards.card_5.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_5.prompt'),
    },
    {
      id: 'card-6',
      description: i18n.t('ai_reports.discover.cards.card_6.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_6.prompt'),
    },
    {
      id: 'card-7',
      description: i18n.t('ai_reports.discover.cards.card_7.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_7.prompt'),
    },
    {
      id: 'card-8',
      description: i18n.t('ai_reports.discover.cards.card_8.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_8.prompt'),
    },
    {
      id: 'card-9',
      description: i18n.t('ai_reports.discover.cards.card_9.description'),
      prompt: i18n.t('ai_reports.discover.cards.card_9.prompt'),
    },
  ]

  const source = useDataCollectionSource<DiscoverCard>({
    dataAdapter: {
      fetchData: () => ({ records: DISCOVER_CARDS }),
    },
    itemOnClick: (item: DiscoverCard) => () => {
      sendPromptForNewDashboard(item.prompt)
    },
    itemActions: (item: DiscoverCard) => [
      {
        label: i18n.t('ai_reports.discover.cards.ask_one'),
        type: 'secondary' as const,
        onClick: () => sendPromptForNewDashboard(item.prompt),
      },
    ],
  })

  return (
    <OneDataCollection
      source={source}
      visualizations={[
        {
          type: 'card',
          options: {
            title: () => '',
            description: (item: DiscoverCard) => item.description,
            avatar: () => ({ type: 'emoji', emoji: '💬' }),
            cardProperties: [],
          },
        },
      ]}
    />
  )
}

export default DiscoverCards
